var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"translate",rawName:"v-translate"}],class:_vm.$style.container,attrs:{"href":_vm.appLoginUrl}},[_vm._v("login")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450f2c8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginButton.vue
// module id = gBk+
// module chunks = 0